import React, { Component } from "react";
import "./style.css";
import { connect } from "react-redux";
import { product } from "../../../models";
import isArray from "../../../function/isArray";
import colorCodes from "../../../function/colorCodes";
import { Translation } from "react-i18next";

class Material extends Component {
  handleClick = data => {
    // actions
    const { setActiveOption } = this.props;
    // reducers
    const { ui } = this.props;
    const index = ui.options.findIndex(item => item.optionId === data.optionId);
    setActiveOption(data.optionId, index);
  };

  goldType = data => {
    let component = "";
    const { ui, activeOptionId, lv1Default } = this.props;
    const isActive = activeOptionId === data.optionId;
    const _option = ui.options.find(item => item.optionId === data.optionId);
    if (isActive) {
      if (lv1Default && colorCodes[lv1Default]) {
        component = (
          <div
            className="color-full"
            style={{ backgroundColor: colorCodes[lv1Default] }}
          />
        );
      }
    } else {
      const defaultType = _option.option.defaultShow.lv1Code;
      if (defaultType && colorCodes[defaultType]) {
        component = (
          <div
            className="color-full"
            style={{ backgroundColor: colorCodes[defaultType] }}
          />
        );
      }
    }

    return component;
  };

  render() {
    const { activeOptionId, options, useColorCode } = this.props;
    const activeMaterial =
      options.find(data => data.optionId === activeOptionId) || {};

    return (
      <div className="option-material-container">
        <div className="subtitle">
          <Translation>{t => t(`rightIndex.options`)}</Translation>
        </div>
        <div className="options-material-wrap">
          {isArray(options) &&
            options.map((data, index) => (
              <div key={index} className="select-box">
                <div
                  className={`colors-circle ${
                    data.optionId === activeOptionId ? "active" : ""
                  }`}
                  onClick={() => this.handleClick(data)}
                >
                  {useColorCode ? (
                    <div
                      className="color-full"
                      style={{
                        backgroundImage: `url(https://cdn.chowsangsang.com/emphasis/web/material/${data.colorCode}.jpg)`
                      }}
                    />
                  ) : (
                    <div
                      className="color-full"
                      style={{
                        backgroundImage: `url(https://cdn.chowsangsang.com/emphasis/web/material/${data.materialCode}.jpg)`
                      }}
                    />
                  )}
                </div>
              </div>
            ))}
        </div>
        <div className="option-name">{activeMaterial.displayText}</div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    ui: state.product.ui,
    activeOptionIndex: state.product.activeOptionIndex,
    activeOptionId: state.product.activeOptionId,
    lv1Default: state.product.lv1Default
  };
};

const mapDispatchToProps = () => {
  return {
    setActiveOption: (id, index) => product.actions.setActiveOption(id, index)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Material);
